module.exports = __webpack_public_path__ + "img/harry_potter_06_and_the_half_blood_prince_scan.63189b9d.jpg";